import styled, { css } from "styled-components"
export const RadioContainer = styled.div`
  ${getInline}
`
export const ItemContainer = styled.div`
  padding: ${({ theme }) => theme.spaces.small};
  cursor: pointer;
`

function getInline({ $inline }) {
  if (!$inline) return css``

  return css`
    display: inline-flex;
  `
}

export const RadioButton = styled.input.attrs({ type: "radio" })`
  transform: scale(1.5);
  margin-right: ${({ theme }) => theme.spaces.small};
`
